// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-modal-result {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 11;
  height: 100%;
  position: fixed;
}
.wrapper-modal-result .close-page {
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
}
.wrapper-modal-result .modal-result {
  top: 0;
  z-index: 2;
  width: 100%;
  padding: 16px;
  overflow: auto;
  max-height: 90vh;
  position: absolute;
  border-radius: 4px;
  background-color: var(--sebrae-white);
  box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);
  display: flex;
  align-items: center;
  flex-direction: column;
}
.wrapper-modal-result .modal-result__header-modal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  max-width: 1216px;
  width: 100%;
}
.wrapper-modal-result .modal-result__header-modal .btn-back {
  padding: 12px;
  font-family: Figtree;
  font-size: 12px;
  font-weight: bold;
  color: var(--sebrae-blue-6);
  border: 1px solid var(--sebrae-blue-6);
  border-radius: 4px;
}
.wrapper-modal-result .modal-result__header-modal .wrapper-titulo {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 6px;
}
.wrapper-modal-result .modal-result__header-modal .wrapper-titulo .wrapper-logo {
  width: 209px;
  height: auto;
}
.wrapper-modal-result .modal-result__header-modal .wrapper-titulo .wrapper-logo img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.wrapper-modal-result .modal-result__header-modal .wrapper-titulo .titulo {
  font-family: Campuni;
  font-size: 24px;
  font-weight: bold;
  color: var(--sebrae-blue-6);
}
.wrapper-modal-result .modal-result__header-modal .wrapper-titulo .empresa {
  font-family: Figtree;
  font-size: 16px;
  font-weight: 400;
  color: var(--sebrae-blue-2);
}
@media (min-width: 768px) {
  .wrapper-modal-result .modal-result__header-modal .btn-back {
    padding: 12px 16px;
    font-size: 16px;
  }
  .wrapper-modal-result .modal-result__header-modal .wrapper-titulo {
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
@media (min-width: 1024px) {
  .wrapper-modal-result .modal-result {
    padding: 24px;
  }
  .wrapper-modal-result .modal-result__header-modal .btn-back {
    padding: 12px 16px;
    font-size: 16px;
  }
  .wrapper-modal-result .modal-result__header-modal .wrapper-titulo {
    gap: 16px;
  }
  .wrapper-modal-result .modal-result__header-modal .wrapper-titulo .titulo {
    font-size: 33px;
  }
  .wrapper-modal-result .modal-result__header-modal .wrapper-titulo .empresa {
    font-size: 19px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/modal-result/index.scss"],"names":[],"mappings":"AAAA;EACI,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACJ;AACI;EACI,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AACR;AAEI;EACI,MAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAAR;AAEQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAAZ;AAEY;EACI,aAAA;EAEI,oBAAA;EACA,eAAA;EACA,iBAAA;EAEJ,2BAAA;EACA,sCAAA;EACA,kBAAA;AAFhB;AAKY;EACI,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;AAHhB;AAIgB;EACI,YAAA;EACA,YAAA;AAFpB;AAGoB;EACI,mBAAA;EACA,WAAA;EACA,YAAA;AADxB;AAKgB;EAEQ,oBAAA;EACA,eAAA;EACA,iBAAA;EAEJ,2BAAA;AALpB;AAOgB;EAEQ,oBAAA;EACA,eAAA;EACA,gBAAA;EAEJ,2BAAA;AAPpB;AAcQ;EAEQ;IACI,kBAAA;IACA,eAAA;EAblB;EAec;IACI,mBAAA;IACA,uBAAA;IACA,mBAAA;EAblB;AACF;AAiBQ;EAtFJ;IAuFQ,aAAA;EAdV;EAgBc;IACI,kBAAA;IACA,eAAA;EAdlB;EAgBc;IACI,SAAA;EAdlB;EAekB;IACI,eAAA;EAbtB;EAekB;IACI,eAAA;EAbtB;AACF","sourcesContent":[".wrapper-modal-result{\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    z-index: 11;\n    height: 100%;\n    position: fixed;\n\n    .close-page {\n        top: 0;\n        left: 0;\n        z-index: 1;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        background-color: rgba(0, 0, 0, 0.5);\n      }\n\n    .modal-result{\n        top: 0;\n        z-index: 2;\n        width: 100%;\n        padding: 16px;\n        overflow: auto;\n        max-height: 90vh;\n        position: absolute;\n        border-radius: 4px;\n        background-color: var(--sebrae-white);\n        box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n\n        &__header-modal{\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            margin-bottom: 32px;\n            max-width: 1216px;\n            width: 100%;\n\n            .btn-back{\n                padding: 12px;\n                font: {\n                    family: Figtree;\n                    size: 12px;\n                    weight: bold;\n                }\n                color: var(--sebrae-blue-6);\n                border: 1px solid var(--sebrae-blue-6);\n                border-radius: 4px;\n            }\n\n            .wrapper-titulo{\n                display: flex;\n                justify-content: flex-start;\n                align-items: flex-start;\n                flex-direction: column;\n                gap: 6px;\n                .wrapper-logo{\n                    width: 209px;\n                    height: auto;\n                    img{\n                        object-fit: contain;\n                        width: 100%;\n                        height: 100%;\n                    }\n                }\n\n                .titulo{\n                    font: {\n                        family: Campuni;\n                        size: 24px;\n                        weight: bold;\n                    }\n                    color: var(--sebrae-blue-6);\n                }\n                .empresa{\n                    font: {\n                        family: Figtree;\n                        size: 16px;\n                        weight: 400;\n                    }\n                    color: var(--sebrae-blue-2);\n                }\n            }\n\n\n        }\n\n        @media(min-width: 768px){\n            &__header-modal{\n                .btn-back{\n                    padding: 12px 16px;\n                    font-size: 16px;\n                }\n                .wrapper-titulo{\n                    flex-direction: row;\n                    justify-content: center;\n                    align-items: center;\n                }\n            }\n        }\n\n        @media(min-width: 1024px){\n            padding: 24px;\n            &__header-modal{\n                .btn-back{\n                    padding: 12px 16px;\n                    font-size: 16px;\n                }\n                .wrapper-titulo{\n                    gap: 16px;\n                    .titulo{\n                        font-size: 33px;\n                    }\n                    .empresa{\n                        font-size: 19px;\n                    }\n\n                    \n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
